import { render } from "./BookingCalendar.vue?vue&type=template&id=05b56da8&scoped=true"
import script from "./BookingCalendar.vue?vue&type=script&lang=js"
export * from "./BookingCalendar.vue?vue&type=script&lang=js"

import "./BookingCalendar.vue?vue&type=style&index=0&id=05b56da8&scoped=true&lang=css"
import "./BookingCalendar.vue?vue&type=style&index=1&id=05b56da8&lang=css"

import exportComponent from "C:\\Ecommerce\\Furbetta\\WebAppPrenotazionePrimaVisita\\booking-prima-visita-v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b56da8"]])

export default __exports__